import {Component} from 'substance'
import PluginListItem from './PluginListItem'

class PluginListComponent extends Component {

    render($$) {
        const el = $$('div')
            .addClass('devtool_pluginlist')
            .ref('pluginList')
            .on('drop', this._onDrop)

        el.append(this._renderListMenu($$))
            .append(
                this.props.config.plugins.map(plugin => this._renderItem($$, plugin, true))
            )
            .append(
                this.props.removed.map(plugin => this._renderItem($$, plugin, false))
            )

        return el
    }

    /**
     * @param $$
     * @returns {VirtualElement}
     * @private
     */
    _renderListMenu($$) {
        const item = $$('div').addClass('menu')
        const name = this._getUniqueEnoughId(5)

        item.append(
            $$('i')
                .addClass('fa fa-download')
                .attr({title: 'Download current configuration'})
                .on('click', () => {
                    this._onDownload()
                })
        )

        item.append(
            $$('i')
                .addClass('fa fa-plus')
                .attr({title: 'Add new plugin to configuration'})
                .on('click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    return this.props.onAdded({
                        id: `tld.domain.${name}`,
                        name: name,
                        url: '',
                        style: '',
                        mandatory: false,
                        enabled: false,
                        data: {}
                    }, true)
                })
        )

        item.append(
            $$('i')
                .addClass('fa fa-minus')
                .attr({title: 'Remove plugin from configuration'})
                .on('click', evt => {
                    this._onRemoved(evt, this.props.selectedPlugin)
                })
        )

        return item
    }

    /**
     * @returns {string}
     * @private
     */
    _getUniqueEnoughId(idLength) {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
        const max = chars.length - 1

        return [...Array(idLength).keys()].reduce((uniqeId) => {
            return uniqeId + chars.substr(Math.floor(Math.random() * max), 1)
        }, '')
    }

    /**
     * @param $$
     * @param plugin
     * @param active
     * @returns {VirtualElement}
     * @private
     */
    _renderItem($$, plugin, active) {
        return $$(PluginListItem, {
            plugin,
            active,
            added: this.props.added.includes(plugin.id),
            overridden: this.props.overridden.includes(plugin.id),
            selected: this.props.selectedPlugin && plugin.id === this.props.selectedPlugin.id,
            onClick: () => {
                this.props.onSelected(plugin)
            },
            onRemoved: (e, plugin) => {
                this._onRemoved(e, plugin)
            },
            onAdded: (e, plugin) => {
                this.props.onAdded(e, plugin)
            },
            onDragStart: (e, plugin) => {
                this._onDragStart(e, plugin)
            },
            dragEnd: () => {
                this.refs.pluginList.removeClass('drag-started')
            }
        }).ref(plugin.id)
    }

    /**
     * @param e
     * @param plugin
     * @returns {boolean}
     * @private
     */
    _onRemoved(e, plugin) {
        e.stopPropagation()
        if (plugin) {
            this.props.onRemoved(plugin)
        }
    }

    /**
     * @param e
     * @param plugin
     * @private
     */
    _onDragStart(e, plugin) {
        e.stopPropagation()
        e.dataTransfer.setData('text/plain', plugin.id)

        this.refs.pluginList.addClass('drag-started')
    }

    /**
     * @param e
     * @private
     */
    _onDrop(e) {
        e.preventDefault()
        e.stopPropagation()

        const droppedId = e.dataTransfer.getData('text')
        const targetId = e.target.id
        const addAfter = e.target.classList.contains('add-below')

        // Tell the substance drag manager that the drag and drop is done
        this.context.dragManager.emit('drag:finished')
        this.context.dragManager.dragState = null

        this.props.onDropped(droppedId, targetId, addAfter)

        const wrapper = this.refs[droppedId]
        wrapper.addClass('drop-succeeded')
        setTimeout(() => wrapper.removeClass('drop-succeeded'), 1000)
    }

    /**
     * @private
     */
    _onDownload() {
        const cfg = JSON.stringify(this.props.config, null, '\t')
        const el = document.createElement('a')
        el.setAttribute('href', `data:application/json;charset=utf-8,${encodeURIComponent(cfg)}`)
        el.setAttribute('download', 'writer-config.json')

        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
    }
}

export default PluginListComponent
